import '../main.css'
import '../../App.css'
import { useCallback, useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode, faMap } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../messageModal';
import { ChevronLeft, Trash2, X, ShoppingBag, Tickets, MapPin, Info } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, changeUnits } from '../common/function';
import { changeAlramModal, checkDuplicateLogins } from '../../store';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Barcode from 'react-barcode';

function CouponBarcode() {
    const navigate = useNavigate();
    const location = useLocation();

    const coupon = location.state?.coupon;

    useEffect(() => {
        if (!coupon) {
            navigate('/coupons')
        }
    }, [])

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                position: 'relative',
                background: '#fff',
            }}
        >
            {/* 닫기(뒤로가기) 버튼 */}
            <div
                style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    cursor: 'pointer',
                    color: '#000',
                    zIndex: 2,
                }}
                onClick={() => navigate(-1)}
            >
                <X style={{ width: '30px', height: '30px' }} />
            </div>

            <div
                style={{
                    width: '100%',
                    height: 'calc(100% - 60px)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: "column",
                    transform: 'rotate(90deg)',
                    transformOrigin: 'center',
                    overflow: 'hidden',
                    fontFamily: 'Noto Sans KR, Spoqa Han Sans, sans-serif',
                }}
            >
                <div style={{ fontSize: "15px", color: "gray", fontWeight: "500", textAlign: "center", marginBottom: "3px" }}>{coupon.ci_brand_name}</div>
                <div style={{ fontSize: "18px", color: "#000", fontWeight: "bold", textAlign: "center", marginBottom: "15px" }}>{coupon.ci_goods_name}</div>
                <Barcode
                    value={coupon.uc_pin_no || '000000000000'}
                    margin={10}
                    width={4}
                    displayValue={false}
                    height={100}
                    background="#fff"
                    lineColor="#000"
                />
                <div style={{ fontSize: "20px", color: "#000", fontWeight: "bold", textAlign: "center" }}>{coupon.uc_pin_no.replace(/(.{4})/g, '$1 ').trim()}</div>
            </div>
        </div>
    );
}

export default CouponBarcode;